// Dashboard Constants - Extracted for cleaner code

// City coordinates for prayer times API
export const CITY_COORDS = {
  'Jakarta': { lat: -6.2088, lng: 106.8456 },
  'Bandung': { lat: -6.9175, lng: 107.6191 },
  'Semarang': { lat: -6.9667, lng: 110.4167 },
  'Surabaya': { lat: -7.2575, lng: 112.7521 },
  'Yogyakarta': { lat: -7.7956, lng: 110.3695 },
  'Bogor': { lat: -6.5950, lng: 106.8167 },
  'Malang': { lat: -7.9797, lng: 112.6304 },
  'Cirebon': { lat: -6.7063, lng: 108.5571 }
}

// Fallback prayer times when API is unavailable
export const FALLBACK_PRAYER_TIMES = {
  Fajr: '04:30',
  Sunrise: '05:45',
  Dhuhr: '12:00',
  Asr: '15:15',
  Maghrib: '18:15',
  Isha: '19:30',
  Imsak: '04:20'
}

// Available cities list
export const CITY_OPTIONS = [
  'Jakarta', 'Bandung', 'Semarang', 'Surabaya',
  'Yogyakarta', 'Bogor', 'Malang', 'Cirebon'
]

// Indonesian holidays 2026
export const HOLIDAYS_2026 = {
  '2026-1-1': { name: 'Tahun Baru 2026 Masehi', color: 'bg-rose-300', type: 'nasional' },
  '2026-1-16': { name: 'Isra Mikraj', color: 'bg-emerald-300', type: 'islam' },
  '2026-2-16': { name: 'Cuti Bersama Tahun Baru Imlek', color: 'bg-sky-300', type: 'cuti' },
  '2026-2-17': { name: 'Tahun Baru Imlek 2577 Kongzili', color: 'bg-amber-300', type: 'nasional' },
  '2026-3-18': { name: 'Cuti Bersama Hari Suci Nyepi', color: 'bg-sky-300', type: 'cuti' },
  '2026-3-19': { name: 'Hari Suci Nyepi Tahun Baru Saka 1948', color: 'bg-orange-300', type: 'hindu' },
  '2026-3-20': { name: 'Cuti Bersama Hari Raya Idul Fitri', color: 'bg-sky-300', type: 'cuti' },
  '2026-3-21': { name: 'Hari Raya Idul Fitri 1447 Hijriah', color: 'bg-emerald-400', type: 'islam' },
  '2026-3-22': { name: 'Hari Raya Idul Fitri 1447 Hijriah', color: 'bg-emerald-400', type: 'islam' },
  '2026-3-23': { name: 'Cuti Bersama Hari Raya Idul Fitri', color: 'bg-sky-300', type: 'cuti' },
  '2026-3-24': { name: 'Cuti Bersama Hari Raya Idul Fitri', color: 'bg-sky-300', type: 'cuti' },
  '2026-4-3': { name: 'Wafat Yesus Kristus', color: 'bg-blue-300', type: 'kristen' },
  '2026-4-5': { name: 'Kebangkitan Yesus Kristus (Paskah)', color: 'bg-blue-300', type: 'kristen' },
  '2026-5-1': { name: 'Hari Buruh Internasional', color: 'bg-rose-300', type: 'nasional' },
  '2026-5-14': { name: 'Kenaikan Yesus Kristus', color: 'bg-blue-300', type: 'kristen' },
  '2026-5-15': { name: 'Cuti Bersama Kenaikan Yesus Kristus', color: 'bg-sky-300', type: 'cuti' },
  '2026-5-27': { name: 'Hari Raya Idul Adha 1447 Hijriah', color: 'bg-emerald-400', type: 'islam' },
  '2026-5-28': { name: 'Cuti Bersama Hari Raya Idul Adha', color: 'bg-sky-300', type: 'cuti' },
  '2026-5-31': { name: 'Hari Raya Waisak 2570 BE', color: 'bg-yellow-300', type: 'buddha' },
  '2026-6-1': { name: 'Hari Lahir Pancasila', color: 'bg-rose-400', type: 'nasional' },
  '2026-6-16': { name: 'Tahun Baru Islam 1448 Hijriah', color: 'bg-emerald-300', type: 'islam' },
  '2026-8-17': { name: 'Hari Kemerdekaan Republik Indonesia', color: 'bg-red-400', type: 'nasional' },
  '2026-8-25': { name: 'Maulid Nabi Muhammad SAW', color: 'bg-emerald-300', type: 'islam' },
  '2026-12-24': { name: 'Cuti Bersama Hari Raya Natal', color: 'bg-sky-300', type: 'cuti' },
  '2026-12-25': { name: 'Hari Raya Natal', color: 'bg-blue-400', type: 'kristen' }
}

// Days of week in Indonesian
export const DAYS_OF_WEEK = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']

// Chart color scheme
export const CHART_COLORS = {
  totalUsers: '#3b82f6',
  activeUsers: '#f97316',
  onlineNow: '#a855f7',
  newToday: '#10b981',
  deleted: '#ef4444'
}

// Prayer time display config
export const PRAYER_LIST = [
  { name: 'Subuh', key: 'Fajr', icon: '🌅', color: 'text-blue-600', bg: 'bg-blue-50' },
  { name: 'Dzuhur', key: 'Dhuhr', icon: '☀️', color: 'text-orange-600', bg: 'bg-orange-50' },
  { name: 'Ashar', key: 'Asr', icon: '🌤️', color: 'text-amber-600', bg: 'bg-amber-50' },
  { name: 'Maghrib', key: 'Maghrib', icon: '🌆', color: 'text-blue-600', bg: 'bg-blue-50' },
  { name: 'Isya', key: 'Isha', icon: '🌙', color: 'text-blue-600', bg: 'bg-blue-50' }
]

// Event color options
export const EVENT_COLORS = [
  'bg-teal-400', 'bg-blue-400', 'bg-pink-400',
  'bg-amber-400', 'bg-purple-400', 'bg-rose-400'
]

// Holiday type labels with emoji
export const HOLIDAY_TYPE_LABELS = {
  nasional: '🇮🇩 Libur Nasional',
  islam: '🕌 Hari Besar Islam',
  kristen: '⛪ Hari Besar Kristen',
  hindu: '🕉️ Hari Besar Hindu',
  buddha: '☸️ Hari Besar Buddha',
  personalleave: '👤 Cuti/Izin Pribadi',
  companyevent: '🎉 Acara Perusahaan',
  cuti: '📅 Cuti Bersama'
}

// Format date helper
export const formatDate = (dateStr) =>
  new Date(dateStr).toLocaleDateString('id-ID')

// Check if a date falls within a user leave period
export const checkUserLeave = (dateObj, userLeaves) => {
  const formattedDate = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`
  const leave = userLeaves.find(l => formattedDate >= l.start_date && formattedDate <= l.end_date)
  if (leave) {
    return {
      name: leave.type === 'sakit' ? 'Izin Sakit' : 'Cuti Tahunan',
      color: leave.type === 'sakit' ? 'bg-purple-300' : 'bg-indigo-300',
      type: 'personalleave'
    }
  }
  return null
}

// Check if a date has a company event
export const checkCompanyEvent = (dateObj, companyEvents) => {
  const formattedDate = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`
  const event = companyEvents.find(e => e.event_date === formattedDate)
  if (event) {
    return {
      name: event.title,
      description: event.description,
      color: event.color || 'bg-teal-400',
      type: 'companyevent'
    }
  }
  return null
}
